import app from './extranet/app';

app.start();
